import { Box, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface DisclosureTextProps {
  joinButtonText?: string;
}

/**
 * Disclosure text shown in pre-call lobby informing users about recording.
 * Matches styling from V1 HairCheck component.
 */
export const DisclosureText: FC<DisclosureTextProps> = ({
  joinButtonText = 'Join',
}) => {
  return (
    <Box
      textAlign="center"
      py="2"
      px="4"
      maxWidth="700px"
      width="100%"
      mx="auto"
    >
      <Text
        fontSize="12px"
        lineHeight="14px"
        sx={{ a: { textDecoration: 'underline' } }}
      >
        By clicking &quot;{joinButtonText}&quot; you agree to the audio
        recording of this session for medical documentation purposes only.
        Recordings are deleted as outlined in Berry Street&apos;s{' '}
        <a
          href="https://www.berrystreet.co/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          href="https://www.berrystreet.co/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Notice
        </a>
        .
      </Text>
    </Box>
  );
};
